const TemplatesListView = () => import("../presentation/views/TemplatesListView.vue");
const TemplateEditorView = () => import("../presentation/views/TemplateEditorView.vue");
export const templatingRoutes = [
    {
        path: "/templating/templates",
        name: "TemplatesList",
        component: TemplatesListView,
        meta: { requiresAuth: true, titleKey: "templating.title" },
    },
    {
        path: "/templating/templates/:id/edit",
        name: "TemplateEditor",
        component: TemplateEditorView,
        meta: { requiresAuth: true, hideHeader: true, titleKey: "templating.title" },
        props: true,
    },
];
export const templatingNavigationItems = [
    {
        labelKey: "templating.title",
        icon: "ri-mail-line",
        children: [
            {
                labelKey: "templating.templates",
                path: "/templating/templates",
                meta: { requiresAuth: true },
            },
        ],
    },
];
